import { render, staticRenderFns } from "./TencentVerify.vue?vue&type=template&id=d9aa3a48"
import script from "./TencentVerify.vue?vue&type=script&lang=js"
export * from "./TencentVerify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports